import ApiService from "@/common/api.service";
import {
  FETCH_BANKS,
  FETCH_BANKUSERS,
  UPDATE_BANKUSERS
} from "../actions.type";

import { SET_BANKS, SET_BANKUSERS } from "../mutations.type";

const state = {
  banks: [],
  bankUsers: []
};

const getters = {
  banks(state) {
    return state.banks;
  },
  bankUsers(state) {
    return state.bankUsers;
  }
};

const mutations = {
  [SET_BANKS](context, banks) {
    state.banks = banks;
  },

  [SET_BANKUSERS](context, bankUsers) {
    state.bankUsers = bankUsers;
  }
};

const actions = {
  [FETCH_BANKS](context, reload = false) {
    if (state.banks.length > 0 && !reload)
      return Promise.resolve(context.banks);

    return ApiService.get("/banks/list").then(banks => {
      context.commit(SET_BANKS, banks);
      return Promise.resolve(banks);
    });
  },

  [FETCH_BANKUSERS](context, data) {
    return ApiService.post("/banks/listBankUsers", data).then(bankUsers => {
      context.commit(SET_BANKUSERS, bankUsers);
      return Promise.resolve(bankUsers);
    });
  },

  [UPDATE_BANKUSERS](context, data) {
    console.log(data);
    return ApiService.post("/banks/updateBankUser", data);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
